export function isAndroid(osName: string) {
  return osName.includes('Android')
}

export function isApple(osName: string) {
  return osName === 'iOS' || osName === 'macOS' || osName === 'Mac OS'
}

export function isIOS(osName: string) {
  return osName === 'iOS'
}

export function isMobileDevice(deviceInfo: App.DeviceInfo): boolean {
  return deviceInfo.deviceType === 'mobile'
}

export function isMobileOrTabletDevice(deviceInfo: App.DeviceInfo): boolean {
  return deviceInfo.deviceType === 'mobile' || deviceInfo.deviceType === 'tablet'
}

export function isMobileAppDevice(userAgentBrowserName: string): boolean {
  return isIOSAppUserAgent(userAgentBrowserName) || isAndroidAppUserAgent(userAgentBrowserName)
}

export function hasCustomisedDownloadHandler(): boolean {
  return typeof window.appInterface?.downloadDataReceived === 'function'
}

/**
 * this selector will also respect in-app navigation via webviews
 */
export function isIOSAppUserAgent(userAgentBrowserName: string) {
  return userAgentBrowserName.includes('mobileapp-ios')
}

/**
 * This selector will also respect in-app navigation via webviews
 */
export function isAndroidAppUserAgent(userAgentBrowserName: string) {
  return userAgentBrowserName.includes('mobileapp-android')
}

/**
 * Returns whether or not this is a web view in the mobile app or not
 * They use custom user agent strings, so we use that to detect it
 * @param userAgent The current user agent
 * @returns Whether or not we are in the app
 */
export function isInMobileApp(userAgent: string): boolean {
  return isIOSAppUserAgent(userAgent) || isAndroidAppUserAgent(userAgent)
}

/**
 * Detects if the device has touch capability
 * @returns true if the device supports touch events
 */
export function hasTouchCapability(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-ignore - for older browsers
    (navigator.msMaxTouchPoints ?? 0) > 0
  )
}
